module.exports = __webpack_public_path__ + "media/images/ctv_preview_modal-2a4edc80.png";